<template>
  <div class="box">
    <div class="box-title">
      <img src="../../../assets/app/information.png" alt="">
      <font>每日资讯</font>
    </div>
    <div class="box-content">
      <div class="box-content-items">
        <p>联合产业启动“5G终端先行者计划先行者计划”</p>
      </div>
      <div class="box-content-items">
        <p>联合产业启动“5G终端先行者计划先行者计划”</p>
      </div>
      <div class="box-content-items">
        <p>联合产业启动“5G终端先行者计划先行者计划”</p>
      </div>
      <div class="box-content-items">
        <p>联合产业启动“5G终端先行者计划先行者计划”</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: true
    }
  },
  props: [],
  watch: {},
  mounted() {},
  methods: {}
}

</script>
<style lang="less" scoped>
@font-color1: #43484D; //标题
@font-color2: #86939E; //一般文字
@font-color3: #0384DF; //蓝色
@font-color4: #FFF; //白色
@font-color5: #31373D; //黑色
.box {
  font-family: "PingFang-SC-Regular";
  overflow: hidden;
}

.box-title {
  color: @font-color1;
  height: 0.84rem;
  line-height: 0.84rem;
  text-align: center;
  font-size: 0.31rem;
  font-family: 'PingFang-SC-Heavy';
  border-bottom: 0.02rem solid #eee;
  img {
    position: relative;
    width: 0.34rem;
    top: 0.05rem;
    margin-right: 0.1rem;
  }
}

.box-content {
  .box-content-items {
    height: 0.73rem;
    line-height: 0.73rem;
    padding: 0 0.3rem;
    border-bottom: 0.02rem solid #eee;
    p {
      font-size: 0.28rem;
      color: #43484D;
      margin: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/app/index/information.vue